export default __webpack_public_path__ + "static/media/goicon-icon-logo.5c0cedea.png";